import { Autocomplete, Button, Grid, InputLabel, OutlinedInput, Stack } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { userService } from "../../../Core/Api/services";
import { DbUserBasicInfos } from "../../../Core/Api/Types/db-user-basic-infos";
import { useTranslation } from "react-i18next";

type CloseClbProps = {
  confirm: boolean;
};

export type ModalSearchUserElementProps = {
  onClose?: (props: CloseClbProps) => void;
  onConfirm: (user: DbUserBasicInfos) => void;
  title?: string;
};
export type ModalSearchUserProps = CommonModalProps<ModalSearchUserElementProps>;

const ModalSearchUser = React.forwardRef<any, ModalSearchUserProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, onClose, onConfirm, title, ...modalProps } = props;
  const [selectedUser, setSelectedUser] = React.useState<DbUserBasicInfos | null>(null);
  const [availableUsers, setAvailableUsers] = React.useState<DbUserBasicInfos[]>([]);

  const onChangeSearch = (entry: string) => {
    if (entry === "" || entry === undefined || entry === null) {
      setAvailableUsers([]);
      return;
    }
    userService.SearchUsersBasic(entry).then(function (response) {
      if (response.success && response.users) setAvailableUsers(response.users);
    });
  };

  const handleConfirmClick = () => {
    if (selectedUser) onConfirm(selectedUser);
  };

  const handleCancelClick = () => {
    closeModal();
  };

  return (
    <Modal
      {...modalProps}
      title={title ? title : t("modal:title.searchForUser")}
      reference={ref}
      closeModal={handleCancelClick}
      width={680}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button variant="contained" color="primary" onClick={handleConfirmClick} disabled={selectedUser === null}>
            {t("common:create")}
          </Button>
        </Stack>
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputLabel htmlFor="searchEmail" sx={{ mb: 1 }}>
            {t("field:label.searchUsersIntoPlatformUsersList")}
          </InputLabel>
          <Autocomplete
            id="searchUser"
            options={availableUsers}
            onChange={(e, value) => {
              if (value) setSelectedUser(value);
            }}
            popupIcon={<ExpandMoreRoundedIcon />}
            getOptionLabel={(option) => option.email + " - " + option.name + " (" + option.id + ")"}
            isOptionEqualToValue={(option, value) => option === value}
            value={selectedUser}
            renderInput={(params) => (
              <OutlinedInput
                {...params.InputProps}
                inputProps={params.inputProps}
                onChange={(e) => onChangeSearch(e.target.value)}
                placeholder={t("field:placeholder.typeNameOrFirstName")}
                required
                sx={{ width: "100%" }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Modal>
  );
});

export default ModalSearchUser;
